import React, { useEffect, useState } from 'react';
import { Container,Card , Button} from 'react-bootstrap';
import AppNavbar from '../../components/Navbar';
import { useNavigate } from 'react-router-dom';

const Subscribe = ()=>{
  
    const navigate = useNavigate();
   


  return (
    <div>
         <AppNavbar/>
    <Container fluid style={{background:'#F9F9F9'}} className='justify-content-center align-items-center text-align-center p-3 p-md-5'>
        
        <Card style={{background:'#fff', maxWidth:'42rem'}} className='p-3 p-md-5 m-auto my-4 border-0 '>
       
        <div className='text-align-center justify-content-center align-items-center text-center'>
        <h3 className='text-center welcome'>Thank you for Subscribing!</h3>
        <p className='account mt-5'style={{fontWeight:'16px'}}>You can explore many offers and features on Tripz when you register with us!</p>
        <div className='justify-content-center align-items-center text-center mt-5'>
        <Button onClick={() => navigate('/signup')}className='' style={{height: '48px',
    width: '241px',
    
    borderRadius: '8px',
    
    backgroundColor: '#008080'}}>Sign Up</Button>
        </div>

      </div>
   
            
        </Card>
       

     </Container>
    
  </div>
    
  )
}

export default Subscribe;
